import AuthGuard from "@components/AuthGuard";
import ROUTES from "@constants/routing";
import { lazy, Suspense } from "react";
import { createBrowserRouter } from "react-router-dom";

const ViewHome = lazy(() => import("@views/ViewHome"));
const ViewLogin = lazy(() => import("@views/ViewLogin"));

export const router = createBrowserRouter([
  {
    path: ROUTES.LOGIN,
    element: (
      <Suspense fallback={null}>
        <ViewLogin />
      </Suspense>
    )
  },
  {
    path: ROUTES.HOME,
    element: (
      <AuthGuard>
        <Suspense fallback={null}>
          <ViewHome />
        </Suspense>
      </AuthGuard>
    )
  }
]);
